import { render, staticRenderFns } from "./storePriceHis.vue?vue&type=template&id=24752ed4"
import script from "./storePriceHis.vue?vue&type=script&lang=js"
export * from "./storePriceHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports